import React, { useState, useEffect } from 'react';
import { Timeline } from 'antd';
import {
  KoDateFormatter,
  KoDP,
  KoEmpty,
  KoLoader,
  KoTitle
} from 'packages';
import styles from './activities.module.scss';
import { DevelopmentAPI } from '../development.service';

export default function Activities({ workspaceId, ticketId }) {
  const [loading, setLoading] = useState(false);
  const [activitiesList, setActivitiesList] = useState({
    activity: [],
    totalCount: 0
  });

  useEffect(() => {
    setLoading(true);
    DevelopmentAPI.getActivities(ticketId, workspaceId).then((res) => {
      setActivitiesList(res?.history || {
        activity: [],
        totalCount: 0
      });
      setLoading(false);
    });
  }, [ticketId, workspaceId]);

  const sortedActivities = [...(activitiesList?.activity || [])].sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );

  return (
    <div className={styles.wrapper}>
      {loading && <KoLoader />}

      {sortedActivities.length > 0 ? (  <Timeline
        mode="left"
        items={sortedActivities.map((activity) => ({
          key: activity.activityId,
          dot: (
            <KoDP
              width={25}
              height={25}
              logo={activity?.createdByProfile?.logo}
              name={`${activity?.createdByProfile?.firstName || ''} ${activity?.createdByProfile?.lastName || ''}`}
            />
          ),
          children: (
            <div className={styles.commentWrapper}>
              <div className={styles.commentHeader}>
                <div className={styles.commentName}>
                  <KoTitle
                    level={4}
                    className={styles.name}
                    text={`${activity?.createdByProfile?.firstName || ''} ${activity?.createdByProfile?.lastName || ''}`}
                  />
                </div>

                <div className={styles.dot} />

                <KoDateFormatter
                  data={activity?.createdAt}
                  format={'DD-MMM-YYYY hh:mm a'}
                />
              </div>

              <div className={styles.comment}>
                {activity?.message?.map((msg, index) => (
                  <div key={index} className={styles.element}>
                    {msg}
                  </div>
                ))}

                {activity?.changes?.length > 0 &&
                  activity?.changes?.map((change, idx) => (
                    <div key={idx} className={styles.element}>
                      <strong>{change.Field}:</strong>{' '}
                      <span className={styles.oldValue}>
                        {change.OldValue}
                      </span>{' '}
                      →{' '}
                      <span className={styles.newValue}>
                        {change.NewValue}
                      </span>
                    </div>
                  ))}
              </div>
            </div>
          )
        }))}
      />) : (
        <KoEmpty width={300} height={200}  title={'No Activity Found'}
          subText={''}
          description={''}/>
      )}
    </div>
  );
}
